import { render, staticRenderFns } from "./LogWorkProcedures.vue?vue&type=template&id=396a05e4&scoped=true&"
import script from "./LogWorkProcedures.vue?vue&type=script&lang=js&"
export * from "./LogWorkProcedures.vue?vue&type=script&lang=js&"
import style0 from "./LogWorkProcedures.vue?vue&type=style&index=0&id=396a05e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a05e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396a05e4')) {
      api.createRecord('396a05e4', component.options)
    } else {
      api.reload('396a05e4', component.options)
    }
    module.hot.accept("./LogWorkProcedures.vue?vue&type=template&id=396a05e4&scoped=true&", function () {
      api.rerender('396a05e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/LogWorkProcedures.vue"
export default component.exports